import { extendTheme } from '@chakra-ui/react';
import {
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_FOOTER,
  ASSET_BACKGROUND,
  ASSET_LOVE_TITLE,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,
    and: FONT_FAMILY.and,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '48px',
    subHeading: '36px',
    body: '16px',
    body_lv2: '24px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    body_lv2: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': 'italic',
        '--fontItalic-and': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgFooter: BG_FOOTER,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
    assetBgColor: ASSET_BACKGROUND,
    assetLoveTitle: ASSET_LOVE_TITLE,
    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'subHeading',
      },
    },
    Radio: {
      variants: {
        custom: {
          control: {
            w: '20px',
            h: '20px',
            backgroundColor: 'transparent',
            borderColor: 'mainColorText',
            borderWidth: '1px',
            _checked: {
              bg: 'bgSecondary',
              borderColor: 'bgSecondary',
              color: 'bgSecondary',
              _hover: {
                bg: 'bgSecondary',
                borderColor: 'bgSecondary',
                color: 'bgSecondary',
              },
            },
          },
        },
      },
    },
  },
};

export default extendTheme(theme);
